import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Loader2 } from "lucide-react";

const API = "/api";

export function CorrectionLogPanel() {
  const { getAuthHeader } = useAuth();
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/integrity/corrections`, { headers: getAuthHeader() })
      .then((r) => setItems(r.data.items))
      .catch(() => setItems([]));
  }, [getAuthHeader]);

  if (!items) return <Loader2 className="w-5 h-5 animate-spin mt-6" />;
  return (
    <Card className="mt-4"><CardContent className="p-0" data-testid="correction-log">
      {items.length === 0 && <p className="p-4 text-sm text-slate-500" data-testid="correction-log-empty">No corrections applied yet.</p>}
      {items.map((c) => (
        <div key={c.id} className="px-4 py-3 border-b border-slate-100 last:border-0 text-sm" data-testid={`correction-${c.id}`}>
          <div className="flex flex-wrap items-center gap-2">
            <Badge variant="outline">{c.kind === "payroll" ? "Payroll" : "Student credits"}</Badge>
            <span className="font-medium">{c.target_name}</span>
            <span className="text-slate-600">{c.original_value} → <strong>{c.corrected_value}</strong>{c.kind === "payroll" ? " classes" : " credits"}</span>
            {c.kind === "payroll" && <span className="text-xs text-slate-500">{c.period_start} → {c.period_end}</span>}
            <span className="ml-auto text-xs text-slate-400">{new Date(c.approved_at).toLocaleString()} · {c.approved_by_name || c.approved_by}</span>
          </div>
          <p className="text-xs text-slate-500 mt-1">Reason: {c.reason}</p>
        </div>
      ))}
    </CardContent></Card>
  );
}
